import { render, staticRenderFns } from "./OleMiss116Lab3PrelabQ1.vue?vue&type=template&id=487ada9c&scoped=true&"
import script from "./OleMiss116Lab3PrelabQ1.vue?vue&type=script&lang=js&"
export * from "./OleMiss116Lab3PrelabQ1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487ada9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
